<template>
  <div
    v-if="isExternal"
    :style="styleExternalIcon"
    class="svg-external-icon svg-icon"
    v-on="$listeners"
  />
  <el-tooltip
    v-else-if="tooltip"
    class="item"
    effect="dark"
    :content="tooltip"
    placement="top"
  >
    <svg
      :class="[svgClass, disabled ? 'cursor-no-drop' : 'cursor-pointer']"
      aria-hidden="false"
      v-on="$listeners"
    >
      <use :xlink:href="iconName" />
    </svg>
  </el-tooltip>
  <svg
    v-else
    :class="[svgClass, disabled ? 'cursor-no-drop' : 'cursor-pointer']"
    aria-hidden="false"
    v-on="$listeners"
  >
    <use :xlink:href="iconName" />
  </svg>
</template>

<script>
import { isExternal } from '@/utils/validate'

export default {
  name: 'SvgIcon',
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    // svg 图标名称
    iconClass: {
      type: String,
      required: true
    },
    // 自定义样式
    className: {
      type: String,
      default: ''
    },
    tooltip: {
      type: String,
      default: ''
    }
  },
  computed: {
    isExternal() {
      return isExternal(this.iconClass)
    },
    iconName() {
      return `#icon-${this.iconClass}`
    },
    svgClass() {
      if (this.className) {
        return 'svg-icon ' + this.className
      } else {
        return 'svg-icon'
      }
    },
    styleExternalIcon() {
      return {
        mask: `url(${this.iconClass}) no-repeat 50% 50%`,
        '-webkit-mask': `url(${this.iconClass}) no-repeat 50% 50%`,
        '-moz-mask': `url(${this.iconClass}) no-repeat 50% 50%`
      }
    }
  }
}
</script>

<style scoped>
.svg-icon {
  width: 1em;
  height: 1em;
  /* vertical-align: -0.15em; */
  vertical-align: middle;
  fill: currentColor;
  overflow: hidden;
  box-shadow: none !important;
  outline-width: 0 !important;
}

.svg-external-icon {
  background-color: currentColor;
  mask-size: cover !important;
  display: inline-block;
}
</style>
